'use es6';

import BasePatternFactory from '../lib/BasePatternFactory';
import MobileUARegex from '../regex/MobileUARegex';
export default BasePatternFactory({
  name: 'MobileUA',
  validator: input => {
    return MobileUARegex.test(input);
  }
});